module.exports = __webpack_public_path__ + "static/media/intro_bold.be322205.TTF";